import React, { useState, useEffect } from 'react'
import { Container, NavDropdown, Navbar, Offcanvas, Nav, Dropdown } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import logo from "../../../assests/logo.png";
import globe from "../../../assests/globe.png";
import useLanguagePersistence from '../../../hooks/useLanguagePersistence';

// import CareerIcon from '../../../assests/careerIcon.png'
// import TestimonialIcon from '../../../assests/testimonial.png'
import './header.css'

function Header() {
  const [scrolled, setScrolled] = useState(false);
  // nightMode=localStorage.getItem('mode');

  const { t, i18n } = useTranslation();
  const { currentLanguage, changeLanguage, availableLanguages } = useLanguagePersistence();
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 0;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <header className={`${scrolled ? 'scrolled' : ''} main-header`} aria-label='main-header'>
      {['lg'].map((expand) => (
        <Navbar key={expand} expand={expand} as="nav" aria-label="Primary navigation">
          <Container className={scrolled ? 'scrolled-header-bg' : 'header-bg'}>
            <Navbar.Brand href="/" aria-label="BringIt Go home">
              {/* <Logo/> */}
              <img className='ms-3' src={logo} alt='BringIt Go logo' width={35} height={35} />

            </Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  What are you looking for
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav variant="underline" className="nav-bar-menu d-flex justify-content-center flex-grow-1 pe-3">
                  <Nav.Link href="/" className={`d-flex me-1 align-items-center`}>
                    {t('home')}
                  </Nav.Link>
                  <NavDropdown
                    className="text-light"
                    title={t('services')}
                    id={`offcanvasNavbarDropdown-expand-${expand}`}
                  >
                    <NavDropdown.Item href="/blockchain">
                      {t('blockchain')}
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/cloud">
                      {t('cloudservices')}
                    </NavDropdown.Item>
                    {/* <NavDropdown.Item href="/unity">
                        Unity Development
                    </NavDropdown.Item> */}
                    {/* <NavDropdown.Item href="/artificial-intelligence">
                        Artificial Intelligence
                    </NavDropdown.Item> */}
                    {/* <NavDropdown.Item href="/mechanical-design">
                        Mechanical Designing
                    </NavDropdown.Item> */}
                    <NavDropdown.Item href="/mobile-development">
                      {t('mobiledevelopment')}
                    </NavDropdown.Item>
                    <NavDropdown.Item href="/web">
                      {t('web')}

                    </NavDropdown.Item>
                    <NavDropdown.Item href="/designing">
                      {t('uxui')}
                    </NavDropdown.Item>
                  </NavDropdown>

                  <Nav.Link href="/portfolio" className={`d-flex me-1 align-items-center`}>
                    {t('portfolio')}
                  </Nav.Link>
                  <Nav.Link href="/about-us" className={`d-flex me-1 align-items-center`}>
                    {t('aboutus')}
                  </Nav.Link>
                  {/* <Nav.Link href="/pricing" className={`d-flex me-1 align-items-center`}>
                        {t('price')}
                  </Nav.Link> */}
                  {/* <Nav.Link href="/#meeting" className={`d-flex me-1 align-items-center`}>
                        
                          {t('getintouch')}
                        
                  </Nav.Link> */}
                  {/* <Nav.Link href="/career" className='me-4'>
                    {t('career')}
                  </Nav.Link> */}

                  {/* {!nightMode?
                    <>
                      <Nav.Link className='d-flex align-items-center night-mode' onClick={handleToggleDayNightMode}>
                        <img className='' width={40} src={NightIcon} alt='Day Mode'/>&nbsp;Light             
                      </Nav.Link>
                    </>
                    :
                    <>
                      <Nav.Link className='d-flex align-items-center day-mode night-text-color' onClick={handleToggleDayNightMode}>
                        Dark&nbsp;
                        <img className='' width={40} src={DayIcon} alt='Night Mode'/>               
                      </Nav.Link>
                    </>
                  } */}
                </Nav>
                {/* <button className='contact-us-btn'>Contact Us</button> */}
                <Dropdown>
                  <Dropdown.Toggle variant="" className='text-light' id="dropdown-basic" aria-label="Select language">
                      <img src={globe} width={18} alt="" aria-hidden="true" /> {currentLanguage?.toUpperCase() || 'EN'}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {availableLanguages.map((lang) => (
                        <Dropdown.Item
                          key={lang.code}
                          active={currentLanguage === lang.code}
                          onClick={() => changeLanguage(lang.code)}
                        >
                          {lang.code.toUpperCase()} - {lang.nativeName}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                </Dropdown>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </header>
  )
}

export default Header
